import React, { InputHTMLAttributes, forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import {
  Arrow,
  ArrowContainerSearch,
  ArrowDivider,
  ContainerResearch,
  IconResearch,
  LabelSelected,
  LabelSelectedProps,
  MenuSearchContainer,
  MenuSearchItem
} from './styles'
import { Input } from '../Input'
import { IconComponent } from '~/assets/icons/component'

export interface IGenericSearchHandle {
  focus: () => void
  clear: () => void
}

export interface Ifield {
  value: string
  label: string
  inputMask?: string
  inputType?: string
}

export interface GenericSearchProps extends LabelSelectedProps, InputHTMLAttributes<HTMLInputElement> {
  fields?: Ifield[]
  handleSearch: (value: string, field: string) => void
  placeholder: string
}

export const GenericSearch = forwardRef<IGenericSearchHandle, GenericSearchProps>((props, ref): JSX.Element => {
  const { fields, handleSearch, placeholder, minWidthLabel, ...inputProps } = props
  const inputRef = useRef<HTMLInputElement>(null)
  const [selectValue, setSelectValue] = useState<string>('')
  const [selectLabel, setSelectLabel] = useState<string>('')
  const [textSearch, setTextSearch] = useState('')
  const [openMenuState, setOpenMenuState] = useState(false)
  const [selectFieldState, setSelectFieldState] = useState<Ifield>()

  const talkEnter = e => {
    if (e.key === 'Enter') {
      handleSearch(textSearch, selectValue)
    }
  }

  useEffect(() => {
    if (fields) {
      setSelectLabel(fields[0].label)
      setSelectValue(fields[0].value)
      setSelectFieldState(fields[0])
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleSelect = (select, id) => {
    setSelectFieldState(fields?.[id])
    if (setSelectLabel) {
      setSelectLabel(select.label)
      setSelectValue(select.value)
    }
  }

  useImperativeHandle(ref, () => ({
    focus: () => {
      if (inputRef.current) inputRef.current.focus()
    },
    clear: () => {
      setTextSearch('')
    }
  }))

  return (
    <ContainerResearch>
      {fields && (
        <>
          <LabelSelected onClick={() => setOpenMenuState(!openMenuState)} minWidthLabel={minWidthLabel}>
            {selectLabel}
            <MenuSearchContainer openMenuState={openMenuState}>
              {fields?.map((itemSearch, id) => {
                if (itemSearch.label !== selectLabel) {
                  return (
                    <MenuSearchItem
                      data-testid="generic-search-menuSearchItem"
                      key={id}
                      onClick={() => {
                        handleSelect(itemSearch, id)
                        setTextSearch('')
                        setOpenMenuState(false)
                      }}
                    >
                      {itemSearch.label}
                    </MenuSearchItem>
                  )
                }
              })}
            </MenuSearchContainer>
            <ArrowContainerSearch>
              <ArrowDivider>
                <Arrow openMenuState={openMenuState}></Arrow>
              </ArrowDivider>
            </ArrowContainerSearch>
          </LabelSelected>
        </>
      )}

      <Input
        ref={inputRef}
        data-testid="generic-search-patient"
        style={{ border: 'none', outline: 'none' }}
        placeholder={placeholder}
        type={selectFieldState?.inputType ?? 'text'}
        mask={selectFieldState?.inputMask}
        value={textSearch ?? undefined}
        onKeyDown={e => talkEnter(e)}
        onChange={event => {
          setTextSearch(event.target.value)
        }}
        onMouseOver={() => setOpenMenuState(false)}
        {...inputProps}
      />
      <IconResearch
        data-testid="generic-search-button"
        disabled={!textSearch}
        onClick={() => handleSearch(textSearch, selectValue)}
      >
        <IconComponent name="search"></IconComponent>
      </IconResearch>
    </ContainerResearch>
  )
})

GenericSearch.displayName = 'GenericSearch'
